<template>
  <div
    class="h-full overflow-auto flex flex-col min-w-[1320Px]"
  >
    <!-- 顶部导航栏 -->
    <Header />
    <el-scrollbar class="flex-1">
      <div
        :ref="(el:any) => setDisplayRef('top', el)"
      />
      <!-- 内容区 -->
      <slot />
      <!-- 底部备案号 -->
      <Footer />
    </el-scrollbar>
    <!-- 微信公众号悬浮框 -->
    <WeChatCode />
  </div>
</template>

<script lang="ts" setup>
import { useMenu } from '~/composables/useMenu'

const { setDisplayRef, scrollToTarget } = useMenu()

const route = useRoute()
const timer = ref<NodeJS.Timeout | null>(null)

watch(() => route.path, () => {
  const hash = route.hash || '#top'
  const target = hash.slice(1)
  if (target === 'top') {
    scrollToTarget(target)
  }
  else {
    timer.value = setTimeout(() => {
      scrollToTarget(target)
    }, 100)
  }
})

onBeforeUnmount(() => {
  if (timer.value) {
    clearTimeout(timer.value)
    timer.value = null
  }
})
</script>

<style lang="scss">

</style>
